import { Box, Container, Grid, Typography } from '@mui/material';
import { EmailMockup, InvoiceEmailMockup } from './ProductMockups';

const ProductPreview = () => {
	return (
		<Box component="section" sx={{ py: { xs: 7, md: 10 } }}>
			<Container maxWidth="lg">
				<Box sx={{ textAlign: 'center', mb: { xs: 5, md: 6 } }}>
					<Typography
						variant="overline"
						color="warning.main"
						sx={{ fontWeight: 700, letterSpacing: '0.14em' }}
					>
						What customers see
					</Typography>
					<Typography
						variant="h4"
						component="h2"
						sx={{ mt: 1, fontWeight: 700 }}
					>
						Branded with your company — not Bidzbase
					</Typography>
					<Typography
						variant="body1"
						color="text.secondary"
						sx={{ mt: 2, maxWidth: 640, mx: 'auto', lineHeight: 1.8 }}
					>
						Every proposal, reminder, and invoice carries your logo, payee
						name, and contact info. Your customer never needs to create an
						account.
					</Typography>
				</Box>
				<Grid container spacing={3}>
					<Grid size={{ xs: 12, md: 6 }}>
						<EmailMockup />
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<InvoiceEmailMockup />
					</Grid>
				</Grid>
			</Container>
		</Box>
	);
};

export default ProductPreview;
